import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const StyledInfoWrapper = styled(FlexRow)`
    align-items: center;
    max-width: 347px;
`;

export const StyledListImage = styled.img`
    width: 100px;
    height: 100px;
`;

export const StyledLoadListInfo = styled.div`
    width: 315px;
    margin-left: 20px;
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
    line-height: 20px;
`;

export const StyledList = styled.ul`
    padding: 8px 0 8px 10px;
    margin-left: 0;
    list-style-type: disc;
`;
